import PropTypes from 'prop-types';

const InsightsSection = ({ insights }) => {
  return (
    <div className="mt-2">
      <div className="bg-blue-50 rounded-md p-4">
        <h4 className="text-sm font-medium text-blue-900 mb-2">Insights</h4>
        <ul className="list-disc list-inside space-y-1">
          {insights.map((insight, index) => (
            <li key={index} className="text-sm text-blue-800">
              {insight}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

InsightsSection.propTypes = {
  insights: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default InsightsSection; 